<template>
  <div class="c-trigger" :class="{'isHide': isHide, 'isOpen': $store.getters.isShowGnav || $store.getters.isShowLinks}">
    <transition name="fade">
    <div class="c-trigger__btn" v-show="!$store.getters.isShowGnav && !$store.getters.isShowLinks" @click="open">
      <div class="c-trigger__btnWrap">
        <span></span>
        <span></span>
      </div>
    </div>
    </transition>
    <div class="c-trigger__close" v-show="$store.getters.isShowGnav || $store.getters.isShowLinks" @click="close($event, true)">
      <div class="c-trigger__closeWrap">
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
  import { assets_path } from '@/_modules/utils/variables';
  import store from '@/_modules/stores';

  export default {
    components: {

    },
    data() {
      return {
        assets_path: assets_path,
        isHide: true
      }
    },
    store,
    computed: {},
    created() {},
    mounted() {
      //console.log(this.$store.getters.getLang);
    },
    methods: {
      start() {
        this.isHide = false;
      },
      open(e) {
        e.preventDefault();
        if (this.$store.getters.isShowGnav) {
          this.$store.commit('setShowGnav', false);
          this.$store.commit('setShowLinks', false);
        } else {
          this.$store.commit('setShowGnav', true);
          this.$store.commit('setShowLinks', false);
        }
      },
      close(e) {
        e.preventDefault();
        this.$store.commit('setShowGnav', false);
        this.$store.commit('setShowLinks', false);
      },
      /*triggerGnav(e, forceClose) {
        if (forceClose) {
          this.$store.commit('setShowGnav', false);
          this.$store.commit('setShowLinks', false);
        } else {
          if (this.$store.getters.isShowGnav) {
            this.$store.commit('setShowGnav', false);
            this.$store.commit('setShowLinks', false);
          } else {
            this.$store.commit('setShowGnav', true);
            this.$store.commit('setShowLinks', false);
          }
        }
      }*/
    }
  }
</script>
